export default __webpack_public_path__ + "0bec1a478306094d7a016f6f9e8f3182.svg";